export const motorcycles = [
  {
    nome: "Fazer 150",
    valor: 18230,
    imagem: "https://iili.io/J78BhRR.png",
  },
  {
    nome: "Fazer 250",
    valor: 24590,
    imagem: "https://iili.io/J78BjNp.png",
  },
  {
    nome: "FZ 150",
    valor: 19990,
    imagem: "https://iili.io/J78BwDN.png",
  },
  // {
  //   nome: "FZ 25",
  //   valor: 30000,
  //   imagem: "https://iili.io/JI9DeHJ.png",
  // },
  {
    nome: "MT03",
    valor: 33390,
    imagem: "https://iili.io/J78BXHv.png",
  },
  {
    nome: "NMAX",
    valor: 21990,
    imagem: "https://iili.io/J78BOxI.png",
  },
];
